export const APPROVED_PR_STATUSES = ["Approved", "Partial PO Created"] as const;

export const APPROVED_PR_STATUS_FILTER = {
  filterField: "status" as const,
  filterValue: [...APPROVED_PR_STATUSES],
};
